import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent {
  @Input()
  labelLeft = 'left';
  @Input()
  labelRight = 'right';
  @Input()
  selected: 'left' | 'right' = 'left';

  @Output()
  select: EventEmitter<'left' | 'right'> = new EventEmitter();

  onSelect() {
    if (this.selected === 'right') {
      this.selectLeft();
    } else {
      this.selectRight();
    }
  }

  selectLeft() {
    this.selected = 'left';
    this.select.emit('left');
  }

  selectRight() {
    this.selected = 'right';
    this.select.emit('right');
  }
}
